<template>
  <div>
    <ul style="list-style:none">
      <li v-for="(item,idx) in tableItems" :key="'table-'+idx">
        <div class="lp-option-item">
          <div>{{ item.name }}</div>
          <div style="flex:1"></div>
          <button class="button half" @click="selOption(item)" style="margin-right:4px" v-if="item.id>0">수정</button>
          <button class="button half is-danger" @click="delOption(tableItems, idx)">삭제</button>
          <i class="material-icons" v-if="!item.selected"
             style="margin-left: 6px;cursor: pointer"
             @click="clickOptionArrow(item)">keyboard_arrow_down</i>
          <i class="material-icons" v-if="item.selected"
             style="margin-left: 6px;cursor: pointer"
             @click="clickOptionArrow(item)">keyboard_arrow_up</i>
        </div>
        <div style="padding:0.75rem" class="columns" v-if="item.selected" v-for="(option,idx) in item.options" :key="'option-'+idx">
          <div class="column">
            <admin-form-item label="옵션값">
              <input class="input"
                     :value="option.name"
                     :disabled="true"
                     type="text" maxlength="20">
            </admin-form-item>
          </div>
          <div class="column">
            <admin-form-item label="옵션가격">
              <div class="flex">
                <input class="input"
                       :value="option.price"
                       :disabled="true"
                       type="number" maxlength="20">
                <div class="flex space-between align-center">
                  <div style="margin-left:3px">원</div>
                </div>
              </div>
            </admin-form-item>
          </div>
        </div>
      </li>
    </ul>
    <div style="padding: 12px 0;">
      <button class="button is-primary" style="width:100%" @click="addOption">옵션 추가하기</button>
    </div>

  <!--
    &lt;!&ndash; 삭제 모달 &ndash;&gt;
    <sweet-modal overlay-theme="dark" ref="delOptModal">
      <lp-modal>
        <div slot="desc">옵션 템플릿을 삭제하시겠습니까?</div>
        <span slot="cancel" @click="$refs.delOptModal.close()">취소</span>
        <span slot="ok" @click="deleteOption">확인</span>
      </lp-modal>
    </sweet-modal>-->
  </div>
</template>

<script>
  import LpInputText from "../../module/common/LpInputText";
  import LpOptPopup from "../../module/common/LpOptPopup";
  import { SweetModal } from "sweet-modal-vue";
  import LpModal from "../../module/common/LpModal.vue";
  import Vue from 'vue';

  export default {
    props: ["selectors", "commercePack"],
    components: {
      LpInputText,
      LpOptPopup,
      SweetModal,
      LpModal
    },
    created() {
      if(this.selectors) this.tableItems = this.selectors;
    },
    data() {
      return {
        tableItems:[]
      };
    },
    watch: {
      selectors(n) {
        this.tableItems = n;
      },
      modalStatus(n){
        if(n==='close'){
          // 상품 옵션 정보 추가, 수정
          if(this.$store.getters.modalResponse.modal_type==='modal-product-option'){
            let item = this.$store.getters.modalResponse;
            // 추가
            if (item.id===0){
              this.tableItems.push(item);
              //this.$emit('addOptPopup', item);
            }
            // 수정
            else {
              for(let i=0; i<this.tableItems.length; i++){
                if(this.tableItems[i].id===item.id) {
                  this.tableItems[i] = item;
                  //this.$emit('addOptPopup', item);
                  break;
                }
              }
            }
          }
          // 상품 옵션 정보 삭제
          else if(this.$store.getters.modalResponse.modal_type==='modal-delete'
            && this.$store.getters.modalResponse.url === 'product/real/selector/'){
            for(let i=0; i<this.tableItems.length; i++) {
              if(this.tableItems[i].id===this.$store.getters.modalResponse.id) {
                removeIndex(this.tableItems, i);
                break;
              }
            }
          }
          // 반환값 초기화
          this.$store.state.modalResponse = {};
        }
      }
    },
    methods: {
      clickOptionArrow(item){
        console.log(item.selected)
        item.selected?item.selected=false:item.selected=true
      },
      // 템플릿 수정
      selOption(item){
        let value = item;
        value.commercePack = this.commercePack;
        this.$store.commit('openModal', {type: 'modal-product-option', value: value });
      },
      // 템플릿 삭제
      delOption(items, index){
        if (items[index].id) {
          let value = {
            id: items[index].id,
            url: 'product/real/selector/',
            title: '상품 옵션을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
        else {
          removeIndex(this.tableItems, index);
        }
      },
      addOption() {
        let value = {
          id: 0,
          name: '',
          selected:true,
          option_type:0,
          type:0,
          required:false,
          options: [{
            name: '',
            price: ''
          }],
        }

        value.commercePack = this.commercePack;
        this.$store.commit('openModal', {type: 'modal-product-option', value: value });
      }
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-option-item
    font-size 0.9rem
    border 1px solid #ccc
    padding 8px
    display flex
    margin-bottom 8px
  .lp-option-item div
    margin auto 0
    margin-right 8px
  .lp-option-item div:last-child
    margin-right 0

  .btn-add-option
    padding 12px
    text-align center
    border 1px solid #ccc
    font-size 0.9rem
</style>
